import Layout from '@/components/feature/Layout';
import Seo, { orgJsonLd, webSiteJsonLd } from '@/components/base/Seo';
import { siteInfo } from '@/mocks/anime';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import { FeaturedSection, LatestSection } from './components/AnimeSection';
import NewsSection from './components/NewsSection';
import FeaturesCta from './components/FeaturesCta';
import FaqSection from './components/FaqSection';

const faqData = [
  { q: '动漫网官网首页如何直达？', a: '收藏本页面网址（https://mangoclick.github.io）即可一键直达动漫网首页。你也可以将动漫网导航页加入浏览器收藏夹，随时快速进入。' },
  { q: '如何快速找到想看的番剧？', a: '使用首页顶部或 Hero 区域的搜索框，输入动漫名即可精准直达。也可以通过动漫分类导航，按题材筛选你感兴趣的作品。' },
  { q: '动漫网的分类有哪些？', a: '动漫网提供热血冒险、校园恋爱、奇幻异界、科幻机甲、悬疑惊悚、治愈日常六大热门分类，直达链接清晰覆盖不同口味。' },
  { q: '收藏动漫网导航页有什么好处？', a: '收藏动漫网导航页就等于把动漫网入口地址握在手里，网址收藏、直达链接、主页导航全都有，想看番直接进，不用再搜来搜去。' },
];

const jsonLd = [
  webSiteJsonLd(),
  orgJsonLd(),
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '动漫网 - 动漫网官网首页',
    url: siteInfo.url,
    description: '动漫网官网首页直达，动漫网网址收藏、直达链接、主页导航全都有。',
    isPartOf: { '@id': siteInfo.url },
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  },
];

export default function Home() {
  return (
    <Layout>
      <Seo
        title="动漫网 - 动漫网官网首页 | 动漫网址收藏与直达导航"
        description="动漫网官网首页直达，收藏这个动漫网导航页就等于把动漫网入口地址握在手里。动漫网网址收藏、直达链接、主页导航全都有，想看番直接进，不用再搜来搜去。"
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <CategorySection />
      <FeaturedSection />
      <LatestSection />
      <NewsSection />
      <FeaturesCta />
      <FaqSection />
    </Layout>
  );
}